import { css } from "@emotion/react";
import { BIZ_UDMincho } from "next/font/google";

const VERIFIED_FORM_ID = 1;

const VerifiedDbLabel = ({ id }: { id: number }) => {
  return id === VERIFIED_FORM_ID ? (
    <p css={verifiedDbLabelStyle}>{"✅ このデータベースは認証されました"}</p>
  ) : null;
};

const verifiedDbLabelStyle = css`
  font-size: 12px;
  color: gray;
  margin-left: 1rem;
`;

const TreasuryRaidLink = () => {
  return (
    <a
      href={
        "https://fussy.gitbook.io/fussy-user-guide/howtocontribute/reidonitsuite/torejar"
      }
      target={"_blank"}
      css={treasuryRaidLinkStyle}
    >
      トレジャリーに寄付する
    </a>
  );
};

const treasuryRaidLinkStyle = css`
  font-size: 12px;
  margin-left: 1rem;
  color: gray;
`;

const font = BIZ_UDMincho({ weight: "700", subsets: ["latin"] });

const AdminThanksHojokin = () => {
  return (
    <p className={font.className}>
      Ｒ１もの補助 機－１ ものづくり補助金事業以外での使用禁止
    </p>
  );
};

export { VerifiedDbLabel, TreasuryRaidLink, AdminThanksHojokin };
